import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-iws-nb-data-table",
    styleUrl: "nb-data-table.scss",
})
export class NbDataTable {
    componentDidLoad() {
        // temporary fix for table width issue of fixed column
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 100);
    }

    render() {
        return (
            <Host class="ux-iws-nb-data-table">
                <slot></slot>
            </Host>
        );
    }
}
